"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConstData = void 0;
var _Box = _interopRequireDefault(require("../Box"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _utils = require("../utils");
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "children", "bold", "className", "error"]; //@todo replace to Grid
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: '10px 0 10px',
      position: 'relative'
    },
    value: {
      lineHeight: '16px'
    },
    label: {
      color: theme.palette.text.secondary,
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left',
      position: 'absolute',
      whiteSpace: 'nowrap',
      top: '-9px'
    },
    bold: {
      fontWeight: 'bold'
    },
    error: {
      color: theme.palette.error.main
    }
  };
});
var defaultGetOptionValue = function defaultGetOptionValue(_ref) {
  var id = _ref.id;
  return id;
};
var defaultGetOptionLabel = function defaultGetOptionLabel(_ref2) {
  var name = _ref2.name;
  return name;
};
var EMPTY_OPTIONS = [];
var Const = function Const(_ref3) {
  var label = _ref3.label,
    children = _ref3.children,
    bold = _ref3.bold,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? {} : _ref3$className,
    error = _ref3.error,
    props = _objectWithoutProperties(_ref3, _excluded);
  var classes = useStyles({
    name: 'GgConst'
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box["default"], {
    className: (0, _clsx2["default"])(classes.root, className),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
      display: 'block',
      className: classes.label,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], _objectSpread(_objectSpread({
      className: (0, _clsx2["default"])(classes.value, _defineProperty(_defineProperty({}, classes.bold, bold), classes.error, !!error))
    }, props), {}, {
      children: children
    })), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormHelperText, {
      error: !!error,
      children: error
    })]
  });
};
var ConstData = exports.ConstData = (0, _utils.withFlexBoxWrapper)(function (_ref4) {
  var value = _ref4.value,
    _ref4$options = _ref4.options,
    options = _ref4$options === void 0 ? EMPTY_OPTIONS : _ref4$options,
    multiple = _ref4.multiple,
    _ref4$getOptionLabel = _ref4.getOptionLabel,
    getOptionLabel = _ref4$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref4$getOptionLabel,
    _ref4$getOptionValue = _ref4.getOptionValue,
    getOptionValue = _ref4$getOptionValue === void 0 ? defaultGetOptionValue : _ref4$getOptionValue,
    className = _ref4.className,
    renderValue = _ref4.renderValue,
    loading = _ref4.loading,
    label = _ref4.label,
    error = _ref4.error;
  var display;
  var displayMultiple = [];
  var displaySingle = null;
  if (loading) {
    display = 'Loading...';
  } else if (renderValue) {
    display = renderValue(value);
  } else if (options && value !== undefined) {
    options.forEach(function (opt) {
      var optValue = getOptionValue(opt);
      var optLabel = getOptionLabel(opt);
      var selected;
      if (multiple) {
        selected = value.includes(optValue);
        if (selected) {
          displayMultiple.push(optLabel);
        }
      } else {
        selected = value === optValue;
        if (selected) {
          displaySingle = optLabel;
        }
      }
    });
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Const, {
    label: label,
    className: className,
    error: error,
    children: display || '—'
  });
});
Const.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired
};
var _default = exports["default"] = Const;